import type { NoticeAppearance } from "../shared/appearance";
import { APPEARANCE_CACHE_KEY_PREFIX } from "./constants";

/**
 * The last appearance served for a notice, so its next load can draw the
 * loading state in the admin's style instead of flashing classic until the
 * notice read returns. Best effort: storage can be absent, full or blocked, and
 * the served value always replaces this one once it arrives.
 */
export const readCachedAppearance = (
  noticeId: string,
): NoticeAppearance | undefined => {
  if (typeof window === "undefined") {
    return undefined;
  }
  try {
    const raw = window.localStorage.getItem(
      `${APPEARANCE_CACHE_KEY_PREFIX}${noticeId}`,
    );
    return raw ? (JSON.parse(raw) as NoticeAppearance) : undefined;
  } catch {
    return undefined;
  }
};

export const writeCachedAppearance = (
  noticeId: string,
  appearance: NoticeAppearance | undefined,
): void => {
  if (typeof window === "undefined") {
    return;
  }
  const key = `${APPEARANCE_CACHE_KEY_PREFIX}${noticeId}`;
  try {
    if (!appearance || Object.keys(appearance).length === 0) {
      window.localStorage.removeItem(key);
      return;
    }
    window.localStorage.setItem(key, JSON.stringify(appearance));
  } catch {
    // Storage is optional here; the notice already renders from the served value.
  }
};
